import Tippy from '@tippyjs/react';
import { ColorNeutralDarkGrey } from 'autogen/design-tokens/tokens';
import { PossibleAdditionalDeliveryCost } from 'autogen/translation-keys/trans-website-shared-productitem';
import Icon from 'components/Icon';
import type { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

// wrapper is needed for tooltip to work on items in product recommendations
const Wrapper = styled.span`
    display: inline-flex;
    vertical-align: text-top;

    // if item is covered by an anchor (productItem)
    position: relative;
    z-index: 2;
`;

export default function AdditionalDeliveryTooltip({ ...restProps }: HTMLAttributes<HTMLSpanElement>): JSX.Element {
    const { t } = useTranslation();

    return (
        <Tippy content={t(PossibleAdditionalDeliveryCost)} theme="plain-tooltip">
            <Wrapper {...restProps}>
                <Icon type="Information" size={16} fill={ColorNeutralDarkGrey} />
            </Wrapper>
        </Tippy>
    );
}
//
